import axiosClient from './axiosClient'

const divisionApi = {
  create: params => axiosClient.post('divisions', params),
  getAll: () => axiosClient.get('divisions'),
  delete: (id) => axiosClient.delete(`divisions/${id}`),
  update: (id, params) => axiosClient.put(`divisions/${id}`, params),
}

export default divisionApi